// extracted by mini-css-extract-plugin
export default {"recommendations":"Recommendations_recommendations__GJofG","title":"Recommendations_title__j0xhZ","cardsContainer":"Recommendations_cardsContainer__YBNV8"};